export enum PdfSettingsCornerStyleEnum {
  ROUNDED = 'ROUNDED',
  ANGULAR = 'ANGULAR',
}
